var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ChevronDown } from '@amsterdam/asc-assets';
import React from 'react';
import Hidden from '../Hidden';
import Icon from '../Icon/Icon';
import FooterHeading from './FooterHeading';
import { FooterContentWrapper, StyledButton, StyledFooterHeading, StyledFooterToggle, } from './FooterSectionStyle';
const ToggleFooterHeader = ({ open, onClick, title, }) => (React.createElement(StyledButton, { variant: "blank", onClick: onClick },
    React.createElement(StyledFooterHeading, null,
        React.createElement(Icon, { rotate: open ? 180 : 0, size: 20 },
            React.createElement(ChevronDown, null)),
        title && title)));
const FooterSection = (_a) => {
    var { title, children } = _a, otherProps = __rest(_a, ["title", "children"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Hidden, { minBreakpoint: "tabletM" },
            React.createElement(StyledFooterToggle, Object.assign({ ToggleHandler: ToggleFooterHeader, title: title, align: "left" }, otherProps),
                React.createElement(FooterContentWrapper, null, children))),
        React.createElement(Hidden, { maxBreakpoint: "tabletM" },
            React.createElement(FooterContentWrapper, null,
                React.createElement(FooterHeading, null, title),
                children))));
};
export default FooterSection;
//# sourceMappingURL=FooterSection.js.map